<div>
  <app-loader #loader />
</div>
